import React from 'react';

import { Text, TextType } from 'ui-components/components/text';

import { OrderDetailsTabSection } from '../section';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';

import style from './text-section.module.less';

export const TextSection = ({ ariaLabelMessageDescriptor, headerMessageDescriptor, contentMessageDescriptor }) => {
  return (
    <OrderDetailsTabSection ariaLabelMessageDescriptor={ariaLabelMessageDescriptor} className={style['text-section']}>
      <Text element='h2' textType={TextType.H4} value={headerMessageDescriptor} />
      <Text textType={TextType.Paragraph} value={contentMessageDescriptor} />
    </OrderDetailsTabSection>
  );
};

TextSection.propTypes = {
  ariaLabelMessageDescriptor: MessageDescriptorPropType.isRequired,
  contentMessageDescriptor: MessageDescriptorPropType.isRequired,
  headerMessageDescriptor: MessageDescriptorPropType.isRequired,
};
